<template>
    <b-container fluid class="settings">

        <h1>{{ actualBusinessName }}</h1>
        <div class="b-name"></div>

        <div class="mt-3">
        <b-row class="exit-button" align-h="end" align-v="center">
            <b-col cols="4" sm="3" md="2">
              <div style="text-align: left;"><router-link to="/open"><b-btn class="btn-red">Exit Admin</b-btn></router-link></div>
    </b-col>
    </b-row>

        <b-row align-h="center" align-v="start">

                <b-col cols="10" sm="10" md="10" lg="5">

                    <b-card class="pricing-card">
                        <h2 class="red">Business Information</h2>

                        <div class="mt-4">

                            <b-row  class="left-align-text">
                            <b-col cols="4">
                                <p class="inline">Business:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ actualBusinessName }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text">
                            <b-col cols="4">
                                <p class="inline">Phone:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ businessPhone }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text">
                            <b-col cols="4">
                                <p class="inline">Address:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ businessAddress }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text">
                            <b-col cols="4">
                                <p class="inline">Country:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ businessCountry }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text">
                            <b-col cols="4">
                                <p class="inline">Prov/State:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ businessProv }}</p>
                                </b-col>
                            </b-row >
<!--
                          <div class="left-align-text">
                                <p class="inline">Pin:</p>
                                <p class="inline ml-3 stat">{{ businessPin }}</p>
                            </div>  -->

                            <b-row  class="left-align-text mt-4">
                            <b-col cols="4">
                                <p class="inline">Ready Text Sent:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ currentTexts }} / <span class="red"> {{ textLimit }} </span> </p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text mt-4">
                            <b-col cols="4">
                                <p class="inline">Marketing Text Sent:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ marketingTextsSent }} </p>
                                </b-col>
                            </b-row >

                            <b-btn class="subs-btns submit-btn mt-3" @click="editBusinessInfo = true">Edit</b-btn>
                        </div>

                    </b-card>
                </b-col>
                <b-col cols="10" sm="10" md="10" lg="5">
                    <b-card class="pricing-card">
                        <h2 class="red">Subscription</h2>

                        <div class="mt-4">

                        <b-row  class="left-align-text mt-4">
                        <b-col cols="4">
                                <p class="inline">Plan:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ plan }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text mt-4">
                            <b-col cols="4">
                                <p class="inline">Monthly:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ cost }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text mt-4">
                            <b-col cols="4">
                                <p class="inline">Ready Text Limit:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ textLimit }}</p>
                                </b-col>
                            </b-row >

                            <div class="mt-3">
                               <b-btn class="subs-btns submit-btn" @click="checkIfUserHasPayingPlan">Update</b-btn>
                            <!--     <b-btn class="subs-btns cancel-btn" @click="cancelSubAlertDialog = true">Cancel</b-btn>-->
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>

        <div class="mt-3">
            <b-row align-h="center" align-v="start">
                <b-col cols="10" sm="10" md="10" lg="5">
                    <b-card class="pricing-card">
                        <h2 class="red">Statistics</h2>

                        <div class="mt-4">

                        <b-row  class="left-align-text mt-4">
                        <b-col cols="4">
                                <p class="inline">Open Orders:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ openOrders }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text mt-4">
                            <b-col cols="4">
                                <p class="inline">Closed Orders:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ closedOrders }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text mt-4">
                            <b-col cols="4">
                                <p class="inline">Total Orders:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ totalOrders }}</p>
                                </b-col>
                            </b-row >

                            <b-row  class="left-align-text mt-4">
                            <b-col cols="4">
                                <p class="inline">Customers:</p>
                                </b-col>
                                <b-col cols="8">
                                <p class="inline">{{ customers }}</p>
                                </b-col>
                            </b-row >
                        </div>
                    </b-card>
                </b-col>
                  <b-col cols="10" sm="10" md="10" lg="5">
                    <b-card class="pricing-card">
                        <h2 class="red ">Tags</h2>
                        <div class="callout mb-5">

                          <p>Tags are one-word descriptions (ie. urgent, repair...) that help organize Orders.  Add Tags then assign then while you create Orders.</p>
                        </div>
                        <!-- <div v-for="(tag, index) in tags" :key="index">
                            <p>{{ tagKeys }} : {{ tag }}</p>
                        </div> -->

                        <div >
                            <tag-table style="padding-left:5px; padding-right:5px;" :items="items" :fields="fields" :hasDeleteButton="true"></tag-table>
                        </div>

                        <b-btn class="subs-btns submit-btn" @click="tagForm = true">Add Tag</b-btn>

                    </b-card>
                </b-col>
            </b-row>
        </div>

        <div class="mt-3 pb-5">
            <b-row align-h="center" align-v="start">
                  <b-col cols="10" sm="10" md="10" lg="5">
                    <b-card class="pricing-card">
                        <h2 class="red">Message Template</h2>
                        <p class="mt-5"></p>
                        <div>
                            <p class="inline left-align-text">Default Text:</p>
                            <p class="inline left-align-text current-text-template">Hi {customer name}, this is {{ actualBusinessName }}.  </p>


                        <div>
                            <p class="inline left-align-text">Custom Text:</p>
                            <p class="inline left-align-text current-text-template">{{ currentTextTemplate }}</p>
                        </div>   </div>


                        <div class="mt-3">
                            <b-form-textarea
                            v-model="newTextTemplate"
                            placeholder="Edit Custom Text"
                            rows="3"
                            max-rows="6"
                            ></b-form-textarea>
                        </div>
                        <div>  <p class="mt-3">Preview: <span class="red ml-3">Hi {customer name}, this is {{ actualBusinessName }}. {{ newTextTemplate }}</span> </p>
                      </div>

                        <b-btn :disabled="!textTemplateState" class="subs-btns submit-btn mt-4" @click="updateTextTemplate">Update</b-btn>
                    </b-card>
                </b-col>

                  <b-col cols="10" sm="10" md="10" lg="5">
                    <b-card class="pricing-card">
                        <h2 class="red">Text Marketing</h2>

                        <div class="callout">

                          <p>Want to drive additional business?  Send text message offers & promotions to your opt-in Customers.</p>
                        </div>

                        <div v-if="(plan == 'standard') || (plan == 'pro')">
                           <div>
                            <p class="translate-y-down">Filter Customers</p>
                            </div>

                            <div>
                                <b-form-select id="tags" size="sm" :options="marketingFilterOptions"
                                v-model="marketingFilterOption"></b-form-select>
                            </div>



                            <div class="mt-3">
                                <b-form-textarea
                                v-model="marketingMessage"
                                placeholder="Marketing message..."
                                rows="3"
                                ></b-form-textarea>
                            </div>

                            <p class="mt-3">Marketing Text Preview: <span class="red ml-3">{{ marketingMessage }}</span> </p>

                            <b-btn :disabled="(!marketMessageState) || (!marketingFilterState)"
                            class="subs-btns submit-btn" @click="viewMarketingMessageSetup">Preview Text</b-btn>

                        </div>

                        <div class="mt-5" v-else>
                            <p>Marketing is only available with Standard and Pro Plans.</p>
                        </div>

                    </b-card>
                </b-col>
            </b-row>
        </div>

        <!-- ______________________________________________ Alert Dialogs ___________________________________________________________________ -->
        <alert-dialog v-if="upgradeSubAlertDialog == true" class="alert-dialog" message="What plan would you like?">
        <b-btn class="cancel-update" @click="upgradeSubAlertDialog = false">X</b-btn>
        <p slot="currentPlan">Current Plan: {{ this.plan }}</p>
        <div slot="pricing-options">
          <b-form-group>
            <b-form-radio-group buttons id="checkboxes1" name="flavour1" v-model="selected" :options="options">
            </b-form-radio-group>
          </b-form-group>
          <p>{{ this.selected }}</p>
          <p v-if="this.selected == ''" class="warning">Please select a Plan.</p>
        </div>
        <b-btn :disabled="((this.selected == '') || (this.btnClicked == true))" class="submit-btn" slot="successBtn" @click="updatePlan">Update</b-btn>
        <b-btn class="cancel-btn" slot="cancelBtn" @click="upgradeSubAlertDialog = false">Cancel</b-btn>
      </alert-dialog>

      <alert-dialog v-if="cancelSubAlertDialog == true" class="alert-dialog" message="Are you sure you want to cancel your subscription?">
        <b-btn class="cancel-update" @click="cancelSubAlertDialog = false">X</b-btn>
        <b-btn :disabled="((this.btnClicked == true))" class="submit-btn" slot="successBtn" @click="cancelPlan">Cancel Subscription</b-btn>
        <b-btn class="cancel-btn" slot="cancelBtn" @click="cancelSubAlertDialog = false">Cancel</b-btn>
      </alert-dialog>

        <alert-dialog v-if="successAlertDialog == true" class="alert-dialog" :message="successMessage">
            <b-btn class="cancel-update" @click="successAlertDialog = false">X</b-btn>
        </alert-dialog>

        <alert-dialog v-if="failAlertDialog == true" class="alert-dialog" :message="failMessage">
            <b-btn class="cancel-update" @click="failAlertDialog = false">X</b-btn>
        </alert-dialog>

        <alert-dialog v-if="tagForm == true" class="alert-dialog" message="Create Tags to categorize your orders. ie. Bike Repair, Skates, Apparel">
              <b-btn class="cancel-update" @click="tagForm = false">X</b-btn>
              <div class="mt-5" slot="formInput">
                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Tag</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newTag" :state="tagState"></b-form-input>
                        <b-form-invalid-feedback class="left-align-text" id="input-live-feedback">
                        Max 20 characters
                        </b-form-invalid-feedback>
                        <!-- <b-form-text class="left-align-text" >Max 20 characters</b-form-text> -->
                    </b-col>
                </b-row>
              </div>
              <b-btn :disabled="!tagState" class="submit-btn" slot="successBtn" @click="addTag">Add Tag</b-btn>
              <b-btn class="cancel-btn" slot="cancelBtn" @click="tagForm = false">Cancel</b-btn>
          </alert-dialog>

          <alert-dialog v-if="editBusinessInfo == true" class="alert-dialog" message="Edit Business Details">
              <b-btn class="cancel-update" @click="editBusinessInfo = false">X</b-btn>
              <div class="mt-5" slot="formInput">
                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Business:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newBusinessName" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Phone:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newBusinessPhone" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Address:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newBusinessAddress" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Country:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newBusinessCountry" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Prov/State:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newBusinessProv" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Pin:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" :state="pinState" v-model="newBusinessPin" ></b-form-input>
                    </b-col>
                </b-row>
              </div>
              <b-btn class="submit-btn" slot="successBtn" @click="editBusinessDetails">Save</b-btn>
              <b-btn class="cancel-btn" slot="cancelBtn" @click="editBusinessInfo = false">Cancel</b-btn>
          </alert-dialog>


          <alert-dialog v-if="viewMarketingMessage == true" class="alert-dialog" message="Marketing Text Preview">
              <b-btn class="cancel-update" @click="viewMarketingMessage = false">X</b-btn>
              <div class="mt-5 ml-5" slot="formInput">

                    <div >
                        <p class="left-align-text">Available Texts: <span class="ml-2 stat">{{ availableTexts }}</span></p>
                    </div>

                    <div >
                        <p class="left-align-text">Message: <span class="ml-2 stat">{{ this.marketingMessage }}</span></p>
                    </div>

                    <div>
                        <p class="left-align-text">Marketing reach: <span class="ml-2 stat">{{ this.marketingReach }}</span></p>
                    </div>

                    <div >
                        <p class="left-align-text">Texts Remaining After Sending: <span class="ml-2 stat">{{ remainingTexts }}</span></p>
                    </div>

                    <div v-if="notEnoughTextsLeft">
                        <p class="red">You don't have enough texts left. Go to your business settings page and upgrade your Plan to keep texting.
                        Or wait until the end of the payment period.</p>
                    </div>

              </div>
              <b-btn :disabled="!canSendMarketingState" class="submit-btn" slot="successBtn" @click="sendMarketingMessage">Send Texts</b-btn>
              <b-btn class="cancel-btn" slot="cancelBtn" @click="viewMarketingMessage = false">Cancel</b-btn>
          </alert-dialog>

        <div class="loader" v-if="isLoading">
            <Loader />
        </div>
    </b-container>
</template>

<script>
import AlertDialog from "../../components/alert-dialog/AlertDialog"
import Loader from "../../components/Loader"
import TagTable from "../../components/settings/tags/TagTable"
import { db } from '@/main'
import firebase, { firestore } from 'firebase'
import axios from 'axios'
export default {
    components: {
        Loader,
        AlertDialog,
        TagTable
    },
    data() {
        return {
            businessName: '',
            actualBusinessName: '',
            businessPhone: '',
            businessAddress: '',
            businessCountry: '',
            businessProv: '',
            businessPin: '',
            newBusinessName: '',
            newBusinessPhone: '',
            newBusinessAddress: '',
            newBusinessCountry: '',
            newBusinessProv: '',
            newBusinessPin: '',
            editBusinessInfo: false,
            plan: '',
            cost: '',
            textLimit: '',
            currentTexts: '',
            upgradeSubAlertDialog: false,
            cancelSubAlertDialog: false,
            selected: 'Starter',
            options: ['Starter', 'Standard', 'Pro'],
            btnClicked: false,
            updateStripeSubApi: 'https://us-central1-readytextme.cloudfunctions.net/updateStripeSubscription',
            cancelStripeSubApi: 'https://us-central1-readytextme.cloudfunctions.net/cancelStripeSubscription',
            newTagApi: 'https://us-central1-readytextme.cloudfunctions.net/addTags',
            stripeErrorMsg: '',
            isLoading: false,
            successAlertDialog: false,
            successMessage: '',
            failAlertDialog: false,
            failMessage: '',
            openOrders: '',
            closedOrders: '',
            customers: '',
            tagForm: false,
            newTag: '',
            tags: null,
            tagKeys: null,
            items: [],
            fields: [
                { key: 'tag', sortable: true },
                { key: 'count', sortable: true },
                { key: 'options', sortable: false },

            ],
            currentTextTemplate: '',
            newTextTemplate: '',
            updateTextTemplateApi: 'https://us-central1-readytextme.cloudfunctions.net/updateDefaultText',
            editBusinessApi: 'https://us-central1-readytextme.cloudfunctions.net/updateBusinessInfo',
            marketingMessage: '',
            marketingFilterOption: '',
            marketingFilterOptions: ['With OPT-IN'],
            marketingSendApi: 'https://us-central1-readytextme.cloudfunctions.net/marketingNotification',
            marketingTextsSent: '',
            textsFinished: false,
            viewMarketingMessage: false,
            marketingReach: '',
            notEnoughTextsLeft: false
        }
    },
    methods: {

        async checkIfUserHasPayingPlan () {
            // console.log("Checking");
            // console.log(this.plan);

            if (this.plan == "trial") {
                this.$router.push({path: '/subscription'});
            } else {
            // TODO toggle simple upgrade dialog
            //    this.upgradeSubAlertDialog = true;
               this.$router.push({path: '/subscription'});
            }

        },
        async updatePlan () {
            // method to update stripe sub
            this.stripeErrorMsg = '';

            // if plan doesn't exist re-route to create plan page

            if (this.selected != '') {

                this.isLoading = true;

                this.upgradeSubAlertDialog = false;

                this.btnClicked = true;

                let plan = ''
                if (this.selected == "Starter") {
                    plan = 'starter';
                }

                if (this.selected == "Standard") {
                    plan = 'standard';
                }

                if (this.selected == "Pro") {
                    plan = 'pro';
                }

                var postContent = {
                    'uid': firebase.auth().currentUser.uid,
                    'pricingPlan': plan,
                    'token': {}
                }

                // console.log('postContent' + JSON.stringify(postContent));
                // request api to update stripe sub
                try {
                    await axios.post(
                    this.updateStripeSubApi,
                    postContent,
                    {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    })
                    this.btnClicked = false;

                    this.isLoading = false;
                    this.successMessage = 'Plan successfully updated';
                    this.successAlertDialog = true;
                } catch (error) {
                    console.log(error);
                    this.failMessage = 'Plan failed to update';
                    this.failAlertDialog = true;
                    // this.stripeErrorMsg = JSON.stringify(error.response);
                    this.isLoading = false;
                    this.btnClicked = false;
                }
            } else {
                this.stripeErrorMsg = '';
                this.isLoading = false;
                this.btnClicked = false;
            }
        },

        async cancelPlan () {
            // method to cancel stripe sub
            this.btnClicked = true;

            this.stripeErrorMsg = '';
            this.isLoading = true;

            this.cancelSubAlertDialog = false

            var postContent = {
            'userId': firebase.auth().currentUser.uid,
            }
            // request api to cancel stripe sub
            try {
                await axios.post(
                this.cancelStripeSubApi,
                postContent,
                {
                    headers: {
                    'Content-Type': 'application/json'
                    },
                })
                this.successMessage = 'Plan successfully cancelled';
                this.isLoading = false;
                this.successAlertDialog = true;


            } catch (error) {
                console.log(error);
                this.failMessage = 'Plan failed to update';
                this.failAlertDialog = true;
                // this.stripeErrorMsg = JSON.stringify(error.response);
                this.isLoading = false;
                this.btnClicked = false;
            }
        },

        async addTag () {
            // method to add tag to db
            this.isLoading = true;

            var postContent = {
            'newTag': this.newTag,
            'business': this.businessName
            }

            // console.log(postContent);
            // request api to add tag to db
            try {
                await axios.post(
                this.newTagApi,
                postContent,
                {
                    headers: {
                    'Content-Type': 'application/json'
                    },
                })
                this.cancelSuccessAlert = true;
                this.successMessage = 'Tag has been added';
                this.tagForm = false;
                this.isLoading = false;
                this.newTag = '';
                this.successAlertDialog = true;
                // this.$forceUpdate();
                this.$router.go(0);

            } catch (error) {
                console.log(error);
                this.tagForm = false;
                this.failMessage = 'Failed to add tag';
                this.failAlertDialog = true;
                this.newTag = '';
                // this.stripeErrorMsg = JSON.stringify(error.response);
                this.isLoading = false;
            }
        },

        async updateTextTemplate () {
            // method to update text message 'additional text'
            this.isLoading = true;

            var postContent = {
            'defaultText': this.newTextTemplate,
            'business': this.businessName
            }

            // console.log(postContent);
            // request api to update default text on db
            try {
                await axios.post(
                this.updateTextTemplateApi,
                postContent,
                {
                    headers: {
                    'Content-Type': 'application/json'
                    },
                })
                this.cancelSuccessAlert = true;
                this.successMessage = 'Template has been updated';
                this.newTextTemplate = ''
                this.isLoading = false;
                this.successAlertDialog = true;

            } catch (error) {
                console.log(error);
                this.failMessage = 'Failed to update template';
                this.newTextTemplate = ''
                this.failAlertDialog = true;
                // this.stripeErrorMsg = JSON.stringify(error.response);
                this.isLoading = false;
            }
        },

        async editBusinessDetails () {
            // method to edit business details
            this.isLoading = true;

            const business = this.businessName;

            // if (this.newBusinessName != '') {
            //     business = this.newBusinessName;
            // }

            var postContent = {
            'country': this.newBusinessCountry,
            'newBusinessName': this.newBusinessName,
            'businessName': business,
            'prov': this.newBusinessProv,
            'uid': firebase.auth().currentUser.uid,
            'address': this.newBusinessAddress,
            'phone': this.newBusinessPhone,
            'pin': this.newBusinessPin
            }

            // console.log(postContent);
            // request api to edit business details
            try {
                await axios.post(
                this.editBusinessApi,
                postContent,
                {
                    headers: {
                    'Content-Type': 'application/json'
                    },
                })
                this.cancelSuccessAlert = true;
                this.editBusinessInfo = false;
                this.successMessage = 'Your Business Information has been updated.';
                this.isLoading = false;
                this.successAlertDialog = true;
                this.newBusinessName = '';
                this.newBusinessPhone = '';
                this.newBusinessAddress = '';
                this.newBusinessCountry = '';
                this.newBusinessProv = '';
                this.newBusinessPin = '';

            } catch (error) {
                console.log(error);
                this.failMessage = 'Sorry, we have failed to update your Business Information.  Please try again.';
                this.editBusinessInfo = false;
                this.failAlertDialog = true;
                // this.stripeErrorMsg = JSON.stringify(error.response);
                this.isLoading = false;
                this.newBusinessName = '';
                this.newBusinessPhone = '';
                this.newBusinessAddress = '';
                this.newBusinessCountry = '';
                this.newBusinessProv = '';
                this.newBusinessPin = '';
            }
        },

        async sendMarketingMessage () {
            // method to send marketing message

            // if text limit reached re-route to texts-finished page
            if (this.textsFinished) {
              this.$router.push({path: '/texts-finished'});
              return;
            }

            this.isLoading = true;

            const business = this.businessName

            var postContent = {
            'marketFilter': this.marketingFilterOption,
            'marketMessage': this.marketingMessage,
            'uid': firebase.auth().currentUser.uid,
            'business': business,
            }

            // console.log(postContent);
            // request api to send marketing message
            try {
                await axios.post(
                this.marketingSendApi,
                postContent,
                {
                    headers: {
                    'Content-Type': 'application/json'
                    },
                })
                this.cancelSuccessAlert = true;
                this.viewMarketingMessage = false;
                this.successMessage = 'Marketing texts have been sent';
                this.isLoading = false;
                this.successAlertDialog = true;
                this.marketingMessage = "";
                this.marketingFilterOption = "";
                this.$router.go(0);

            } catch (error) {
                console.log(error);
                this.viewMarketingMessage = false;
                this.failMessage = 'Failed to send marketing texts';
                this.failAlertDialog = true;
                // this.stripeErrorMsg = JSON.stringify(error.response);
                this.isLoading = false;
                this.marketingMessage = "";
                this.marketingFilterOption = "";
            }
        },

        //
        async viewMarketingMessageSetup () {

            const userInfo = await firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid).get();
            let marketingTextsSent = userInfo.data().marketingTextsSent;
            let readyTextsSent = userInfo.data().readyTextsSent;

            //if marketFilter in the query is Opt-in, get all customers who opt in
            if (this.marketingFilterOption === 'With OPT-IN'){
                const customerDocs = await firebase.firestore().collection('businesses').doc(this.businessName).collection('customers').where('marketingOpt', '==', true).get();
                this.marketingReach = customerDocs.size;
            } else if (this.marketingFilterOption.includes('With tag:')) {
                const tag = this.marketingFilterOption.slice(10, this.marketingFilterOption.length);
                const customerDocs = await firebase.firestore().collection('businesses').doc(this.businessName).collection('customers').where('marketingOpt', '==', true).where('tags', "array-contains", tag).get();
                this.marketingReach = customerDocs.size;
            }

            this.viewMarketingMessage = true;
        }
    },
    computed: {
        // method to return total number of orders
        totalOrders () {
            return this.openOrders + this.closedOrders;
        },

        tagState () {
            // method to make sure tags don't exceed 20 characters
            return this.newTag.length > 0 && this.newTag.length < 21 ? true : false
        },

        textTemplateState () {
            // method to make sure text template doesn't exceed 250 characters
            return this.newTextTemplate.length > 0 && this.newTextTemplate.length < 251 ? true : false
        },

        pinState () {
            // method to make sure pin is above 3 and below 5 characters
            return this.newBusinessPin.length > 3 && this.newBusinessPin.length < 5 ? true : false;
        },

        marketMessageState () {
            // method to make sure marketing message is above 0 and below 145
            return this.marketingMessage.length > 0 && this.marketingMessage.length < 145 ? true : false;
        },

        canSendMarketingState () {
            // method to check to see if textLimit has been reached
            return this.currentTexts + this.marketingReach <= this.textLimit ? true : false;
        },

        marketingFilterState () {
            return this.marketingFilterOption != '' ? true : false;
        },

        availableTexts () {
            // method to show how number of available texts
            const available = this.textLimit - this.currentTexts;
            return available;
        },

        remainingTexts () {
            // method to show how many text remain after sending out current marketing message
            const remaining = this.textLimit - (this.currentTexts + this.marketingReach);
            if (remaining < 0) {
                this.notEnoughTextsLeft = true;
            } else {
                this.notEnoughTextsLeft = false;
            }
            return remaining;
        }
    },
    async created() {
        var vueInstance = this;
        // getting data from db
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async(doc) => {
            vueInstance.businessName = doc.data().business;
            vueInstance.businessPin = doc.data().pin;
            vueInstance.newBusinessPin = doc.data().pin;
            vueInstance.plan = doc.data().plan;
            vueInstance.currentTexts = doc.data().readyTextsSent;
            vueInstance.marketingTextsSent = doc.data().marketingTextsSent;
            const business = doc.data().business;
            if (vueInstance.plan == "trial") {
                vueInstance.textLimit = '10'
                vueInstance.cost = 'Free'
            }

            if (vueInstance.plan == "starter") {
                vueInstance.textLimit = '200'
                vueInstance.cost = '$35/mo'
            }

            if (vueInstance.plan == "standard") {
                vueInstance.textLimit = '500'
                vueInstance.cost = '$75/mo'
            }

            if (vueInstance.plan == "pro") {
                vueInstance.textLimit = '1,500'
                vueInstance.cost = '$125/mo'
            }

            const textsFinishedBool = doc.data().planTextsFinished;

            if (textsFinishedBool == 1) {
            this.textsFinished = true;
            }
            // getting open orders from db
            const snapshot = await db.collection('businesses').doc(business).collection('orders').where('orderObj.status', '>=', 'open')
            .onSnapshot(querySnapshot => {
                const openArray = querySnapshot.docs.map(doc => doc.data().orderObj);
                querySnapshot.forEach(doc => {
                })
                vueInstance.openOrders = openArray.length;
            });
            // getting closed orders from db
            const snapshotClosed = await db.collection('businesses').doc(business).collection('orders').where('orderObj.status', '==', 'closed')
            .onSnapshot(querySnapshot => {
                const openArray = querySnapshot.docs.map(doc => doc.data().orderObj);
                querySnapshot.forEach(doc => {
                })
                vueInstance.closedOrders = openArray.length;
            });

            // getting business details from db
            const businessSnapshot = await db.collection('businesses').doc(business).onSnapshot(async (docc) => {
                vueInstance.items = [];
                vueInstance.tags = docc.data().tags;
                vueInstance.currentTextTemplate = docc.data().defaultText;
                vueInstance.businessPhone = docc.data().phone;
                vueInstance.businessAddress = docc.data().address;
                vueInstance.businessCountry = docc.data().country;
                vueInstance.businessProv = docc.data().state;
                vueInstance.actualBusinessName = docc.data().businessName;

                vueInstance.newBusinessName = docc.data().businessName;
                vueInstance.newBusinessPhone = docc.data().phone;
                vueInstance.newBusinessAddress = docc.data().address;
                vueInstance.newBusinessCountry = docc.data().country;
                vueInstance.newBusinessProv = docc.data().state;
                // console.log(vueInstance.tags);
                vueInstance.tagKeys =  Object.keys(docc.data().tags);
                const tKeys = Object.keys(docc.data().tags);

                for (let i = 0; tKeys.length > i; i++) {
                    const key = "With tag: " + tKeys[i];

                    this.marketingFilterOptions.push(key);
                }


                const tagValue = Object.values(docc.data().tags);

                for (let i = 0; tagValue.length > i; i++) {
                    const obj = {
                        "tag": this.tagKeys[i],
                        "count": tagValue[i]
                    }


                    this.items.push(obj);
                }
            });

            // customer query
            const customerDoc = await firebase.firestore().collection('businesses').doc(business).collection('customers').get();
            vueInstance.customers = customerDoc.size;
        });
    },
}
</script>

<style scoped>
.settings {
    margin-top: 100px;
}

.exit-button {
    padding-bottom: 20px;

}

.pricing-card {
text-align: left;

    margin-top: 20px;
    background-color: #f5f4f4;
    /* background-color: #DA2a2a; */
    min-height: 400px;
    /* padding: 30px 20px 5px 20px; */
    border-radius: 3px;
    box-shadow: 0px 0px 5px 0px #d1d1d1;
}

.inline {
    display: inline;
    text-align: start;
}

.subs-btns {
    margin: 3px 5px;
}

.red {
    color: #bb2828;
}

.cancel-update {
  background-color: #E05555;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  font-size: 1em;
}

.alert-dialog {
  position: fixed;
  border: 1px solid #929292;
  border-radius: 5px;
  padding: 20px 20px;
  background-color: #ececec;
  width: 700px;
  z-index: 3;
  top: 20%;
  transform: translateY(-50%);
  left: 50%;
  transform: translateX(-50%);
}

.warning {
  color: #dd7d2e !important;
}

.b-name {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    padding-top: 2px;
    border-bottom: 3px solid #DA2a2a;
    /* border-radius: 10px; */
}

.loader {
    position: fixed;
    width: 350px;
    height: 350px;
    z-index: 100;
    padding-top: 70px;
    /* top: 0; */
    bottom: 30%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #c0c0c0;
    border-radius: 5px;
    transition: all 0.8s ease;
}

.red {
    /* color: #ffffff; */
    color: #DA2a2a;
}

.stat {
    font-weight: 600;
    letter-spacing: 1px;
    padding-left: 10px;
}

.exit-button {
    text-align: center;
    font-size: 18px;
}

.left-align-text {
    text-align: left;
}

.left-align-text-center-position {
    text-align: left;
}

.card-center {
    margin: 0;
    position: absolute;
    /* top: 50%; */
    left: 50%;
    transform: translateX(-50%);
}

.current-text-template {
    padding-left: 20px;
    color: #7e7e7e;
    font-weight: 500;
    text-align: left;
}

.translate-y-down {
    transform: translateY(20px);
}

@media (max-width: 600px) {
    .alert-dialog {
        width: 380px;
    }
}

.btn-red {
    background-color: #DA2a2a;
    border: none;
    border-radius: 5px;
    margin-top: 10px;
    maring-bottom: 20px;
}

.btn-red:hover {
    background-color: #d68181;

}


.callout {
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 5px;

background-color: #e4cbcb;

  border-radius: 3px;

}






</style>
